<ion-content>
<div class="teacher-app-popover" [style.min-width]='minWidth ? minWidth + "px" : ""'>
  <div class='items'>
    <ng-container *ngFor='let item of items'>
      <button *ngIf='!isDivider(item) && hasIcon(item)' (click)='select(item)'><i class='fa {{item.icon}}'></i> {{item.name}}</button>
      <button *ngIf='!isDivider(item) && !hasIcon(item)' (click)='select(item)'>{{item.name}}</button>
      <div class='divider' *ngIf='isDivider(item)'></div>
    </ng-container>
  </div>
</div>
</ion-content>